export default {
  brand: 'ITEX',

  logo: {
    type: 'text',
    primary: 'I.T.EX',
    secondary: 'New Vision',
  },

  footer: {
    leftBrand: {
      text: 'I.T.Ex New Vision',
      className: 'footer__itex',
    },
    release: {
      text: 'release Mazzilli',
      className: 'footer__release',
      showYear: true,
    },
    poweredBy: {
      text: 'Powered by',
      className: 'footer__powered',
    },
    rightBrand: {
      text: 'Astron Technologies',
      className: 'footer__astron',
    },
  },

  features: {
    inquiries: false,
    jobs: true,
    workOrders: true,
    clients: true,
    vendors: true,
    inspectors: true,
    agencies: true,
    dataManagement: true,
    userManagement: false,
    standardsMaster: false,
    clientQmsCertificates: false,
    frameworkAgreements: false,
  },
};
